var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "ml-2 mr-3 mb-3" },
    [
      _c(
        "v-container",
        { staticClass: "pa-0" },
        [
          _c(
            "v-toolbar",
            { attrs: { card: "", dense: "" } },
            [
              _c(
                "v-toolbar-side-icon",
                [
                  _c(
                    "v-chip",
                    {
                      attrs: {
                        color: _vm.dispatchSpread <= 0 ? "red" : "green",
                        "text-color": "white",
                        small: ""
                      }
                    },
                    [
                      _vm._v(
                        "\n          $" +
                          _vm._s(_vm.dispatchSpread) +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-toolbar-title",
                {
                  class: _vm.isDispatchActive(_vm.dispatch)
                    ? ""
                    : "font-weight-light font-italic"
                },
                [_vm._v("ID: " + _vm._s(_vm.dispatch.humanId))]
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _vm.isDispatchActive(_vm.dispatch)
                ? _c(
                    "v-icon",
                    {
                      attrs: { color: "accent" },
                      on: {
                        click: function($event) {
                          return _vm.cancelDispatchRequest(_vm.dispatch)
                        }
                      }
                    },
                    [_vm._v("\n        cancel\n      ")]
                  )
                : _c("v-icon", { attrs: { disabled: "" } }, [
                    _vm._v("highlight_off")
                  ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list",
            [
              _c(
                "v-list-tile",
                [
                  _c(
                    "v-list-tile-action",
                    [
                      _c(
                        "v-chip",
                        {
                          attrs: {
                            color: "primary",
                            "text-color": "white",
                            small: ""
                          }
                        },
                        [_c("v-icon", [_vm._v("send")])],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-content",
                    [
                      _c("v-list-tile-title", [
                        _vm._v(_vm._s(_vm.dispatch.createdByDisplayName))
                      ]),
                      _vm._v(" "),
                      _c("v-list-tile-sub-title", [
                        _vm._v(
                          _vm._s(_vm._f("formatDate")(_vm.dispatch.created))
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              !_vm.isDispatchActive(_vm.dispatch)
                ? _c(
                    "v-list-tile",
                    [
                      _c(
                        "v-list-tile-action",
                        [
                          _c(
                            "v-chip",
                            {
                              attrs: {
                                color: "primary",
                                "text-color": "white",
                                small: ""
                              }
                            },
                            [_c("v-icon", [_vm._v("highlight_off")])],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-content",
                        [
                          _c("v-list-tile-title", [
                            _vm._v(_vm._s(_vm.dispatch.retractedByDisplayName))
                          ]),
                          _vm._v(" "),
                          _c("v-list-tile-sub-title", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatDate")(_vm.dispatch.retracted)
                              )
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-list-tile",
                [
                  _c(
                    "v-list-tile-action",
                    [
                      _c(
                        "v-chip",
                        {
                          attrs: {
                            color: "primary",
                            "text-color": "white",
                            small: ""
                          }
                        },
                        [
                          _vm.includeCustomer
                            ? _c("v-icon", [_vm._v("person_add")])
                            : _c("v-icon", [_vm._v("person_add_disabled")])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-content",
                    [
                      _c("v-list-tile-title", [
                        _vm._v("Customer "),
                        !_vm.includeCustomer
                          ? _c("span", [_vm._v("not")])
                          : _vm._e(),
                        _vm._v(" included")
                      ]),
                      _vm._v(" "),
                      _c("v-list-tile-sub-title", [
                        _vm._v(
                          "on the Load Details and " +
                            _vm._s(_vm.$t("terms.bill-of-lading"))
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-tile",
                [
                  _c(
                    "v-list-tile-action",
                    [
                      _c(
                        "v-chip",
                        {
                          attrs: {
                            color: "primary",
                            "text-color": "white",
                            small: ""
                          }
                        },
                        [_c("v-icon", [_vm._v("monetization_on")])],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-content",
                    [
                      _c("v-list-tile-title", [
                        _vm._v("Pays $" + _vm._s(_vm.dispatch.payableAmount))
                      ]),
                      _vm._v(" "),
                      _vm.billableAmount
                        ? _c("v-list-tile-sub-title", [
                            _vm._v("Bills $" + _vm._s(_vm.billableAmount))
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm.specificDispatchRecipients
                ? [
                    _c(
                      "v-list-tile",
                      [
                        _c(
                          "v-list-tile-action",
                          [
                            _c(
                              "v-chip",
                              {
                                attrs: {
                                  color: "primary",
                                  "text-color": "white",
                                  small: ""
                                }
                              },
                              [_c("v-icon", [_vm._v("share")])],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list-tile-content",
                          [
                            _c("v-list-tile-title", [
                              _vm._v("Dispatch Recipients")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-list-tile",
                      [
                        _c(
                          "v-card",
                          { staticClass: "ml-5" },
                          _vm._l(_vm.specificDispatchRecipients, function(
                            invited
                          ) {
                            return _c(
                              "div",
                              { key: invited.id, staticClass: "pl-2" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(invited.companyName) +
                                    "\n          "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ],
                      1
                    )
                  ]
                : [
                    _c(
                      "v-list-tile",
                      [
                        _c(
                          "v-list-tile-action",
                          [
                            _c(
                              "v-chip",
                              {
                                attrs: {
                                  color: "primary",
                                  "text-color": "white",
                                  small: ""
                                }
                              },
                              [_c("v-icon", [_vm._v("share")])],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list-tile-content",
                          [
                            _c("v-list-tile-title", [
                              _vm._v("Dispatch Recipients")
                            ]),
                            _vm._v(" "),
                            _c("v-list-tile-sub-title", [
                              _vm._v("ALL members of your Preferred Carriers")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
              _vm._v(" "),
              _c(
                "v-list-tile",
                [
                  _c(
                    "v-list-tile-action",
                    [
                      _c(
                        "v-chip",
                        {
                          attrs: {
                            color: "primary",
                            "text-color": "white",
                            small: ""
                          }
                        },
                        [_c("v-icon", [_vm._v("visibility")])],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-tile-content",
                    [
                      _c("v-list-tile-title", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.dispatchRequestVisibleCount(_vm.dispatch)
                            ) +
                            " visible\n            " +
                            _vm._s(
                              _vm._f(
                                "pluralize"
                              )(
                                _vm.dispatchRequestVisibleCount(_vm.dispatch),
                                "load",
                                { includeNumber: false }
                              )
                            ) +
                            "\n          "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.dispatchFollowers, function(follower, idx) {
                return _vm.dispatchFollowers
                  ? _c(
                      "v-list-tile",
                      { key: follower + idx },
                      [
                        _c(
                          "v-list-tile-action",
                          [
                            idx == 0
                              ? _c(
                                  "v-chip",
                                  {
                                    attrs: {
                                      color: "primary",
                                      "text-color": "white",
                                      small: ""
                                    }
                                  },
                                  [
                                    _c("v-icon", [
                                      _vm._v("notifications_active")
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-list-tile-content",
                          [
                            _c("v-list-tile-title", [
                              _vm._v(_vm._s(follower.name))
                            ]),
                            _vm._v(" "),
                            _c("v-list-tile-sub-title", [
                              _vm._v(_vm._s(follower.companyNames))
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d2ee7dd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d2ee7dd4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Loads/components/DispatchRequest.vue
// module id = null
// module chunks = 